import {Injectable} from "@angular/core";
import {Headers, Http, RequestMethod, RequestOptionsArgs, Response} from "@angular/http";
import {Alert, AlertController, App} from "ionic-angular";
import "rxjs/add/observable/throw";
import {Observable} from "rxjs/Observable";
import {ServiceConfig} from "../app/services-config";

@Injectable()
export class HttpService {
  private appConfigObservable: Observable<any>;
  protected appConfig: any;

  constructor(protected http: Http,
              protected app: App,
              protected alertCtrl: AlertController) {
  }

  private formatParams(params?: any, prefix?: string) {
    if (typeof params === 'undefined') {
      return;
    }

    if (params === null || params === '') {
      if (prefix) {
        return `${prefix}=`;
      }

      return;
    }

    if (typeof params !== 'object') {
      if (!prefix) {
        return params;
      }

      if (params === true || params === false) {
        return `${prefix}=${params === true ? 1 : 0}`;
      }

      return `${prefix}=${params}`;
    }

    if (prefix && Array.isArray(params)) {
      if (!params.length) {
        return;
      }
      return params.map(param => {
        return this.formatParams(param, prefix + '[]');
      }).join('&');
    }

    return Object.keys(params).map(key => {
      return this.formatParams(params[key], prefix ? `${prefix}[${key}]` : key);
    }).filter(value => !!value).join('&');
  }

  public loadAppConfig(): Observable<any> {
    if (!this.appConfig) {
      if (!this.appConfigObservable) {
        this.appConfigObservable = this.get(ServiceConfig.schoolUrl)
          .map((response) => response.json())
          .publishReplay(1)
          .refCount();

        this.appConfigObservable.subscribe(appConfig => {
          this.appConfig = appConfig;
          this.appConfigObservable = null;
        }, error => {
          console.error(error);
        });
      }

      return this.appConfigObservable;
    }

    return Observable.of(this.appConfig);
  }

  public get(url: string, params?: any) {
    return this.request(ServiceConfig.baseUrl + url, {method: RequestMethod.Get, params: this.formatParams(params)});
  }

  public getAbsolute(url: string, params?: any) {
    return this.request(url, {method: RequestMethod.Get, params});
  }

  public post(url: string, body?: any, params?: any) {
    return this.request(ServiceConfig.baseUrl + url, {
      method: RequestMethod.Post,
      body,
      params: this.formatParams(params)
    });
  }

  public put(url: string, body: any, params?: any) {
    return this.request(ServiceConfig.baseUrl + url, {
      method: RequestMethod.Put,
      body,
      params: this.formatParams(params)
    });
  }

  public delete(url: string, body?: any, params?: any) {
    return this.request(ServiceConfig.baseUrl + url, {
      method: RequestMethod.Post,
      body,
      params: this.formatParams(params)
    });
  }

  protected request(url: string, options: RequestOptionsArgs): Observable<Response> {
    options.headers = options.headers || new Headers();
    options.headers.set('Accept', 'application/json');

    // if ((options.method === RequestMethod.Post || options.method === RequestMethod.Put)) {
    //   if (options.body instanceof FormData) {
    //     options.headers.set('enctype', 'multipart/form-data');
    //   } else if (!options.headers.has('Content-Type')) {
    //     options.headers.set('Content-Type', 'application/json');
    //   }
    // }

    return this.http.request(url, options)
      .catch(error => {
        if (error instanceof Response) {
          let alert: Alert;
          const navCtrls = this.app.getRootNavs();

          if (navCtrls.length) {
            return new Promise((resolve, reject) => {
              const active = navCtrls[0].getActive();
              const home = !!active && active.id === 'HomePage';
              const back = navCtrls[0].canGoBack();
              const buttons = [];
              const retry = {
                text: 'Opnieuw',
                handler: () => {
                  alert.dismiss().then(() => {
                    this.request(url, options).subscribe(resolve, reject);
                  });
                  return false;
                }
              };

              if (!home || back) {
                buttons.push({
                  text: 'Terug',
                  role: 'cancel',
                  handler: () => {
                    alert.dismiss().then(() => {
                      if (!back) {
                        navCtrls[0].setRoot('HomePage');
                      } else {
                        navCtrls[0].pop();
                      }
                      reject(error);
                    });
                    return false;
                  }
                });
              }

              switch (error.status) {
                case -1:
                case 0:
                  buttons.push(retry);

                  alert = this.alertCtrl.create({
                    title: 'Netwerkfout',
                    message: 'Er kon geen verbinding gemaakt worden met de server, controleer uw netwerkverbinding en probeer het opnieuw',
                    buttons
                  });

                  alert.present();
                  return;
                case 404:
                  alert = this.alertCtrl.create({
                    title: 'Niet gevonden',
                    message: 'Het item is niet meer beschikbaar op de server, ga terug en kies een ander item',
                    buttons
                  });

                  alert.present();
                  return;
              }

              if (Math.floor(error.status / 100) === 5) {
                buttons.push(retry);

                alert = this.alertCtrl.create({
                  title: 'Serverfout',
                  message: 'Er is iets misgegaan op de server, probeer het later opnieuw.',
                  buttons
                });

                alert.present();
                return;
              }

              reject(error);
            });
          }
        }

        return Observable.throw(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/http.service.ts